import { render } from "./PosPurchase.vue?vue&type=template&id=68a7b9d4&scoped=true&ts=true"
import script from "./PosPurchase.vue?vue&type=script&lang=ts"
export * from "./PosPurchase.vue?vue&type=script&lang=ts"

import "./PosPurchase.vue?vue&type=style&index=0&id=68a7b9d4&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a7b9d4"]])

export default __exports__